// ENTITIES ##########################################################
// MODEL USED FOR TRANSITION APP<->API (TransitionalModelObject)

// MODEL USED IN APPLICATION (with additional properties)


// INTERFACES ########################################################
// API interfaces ****************************************************
// UI interfaces *****************************************************


// ENUMS #############################################################
// API enums *********************************************************

// UI enums *********************************************************
export enum ChartColorTypeEnum {
	STATUS = 'status',
	TENANT = 'tenant',
	SIGNATURES = 'signatures',
	TSS_MODE = 'tssMode',
}

export enum TransactionOverviewTypeEnum {
	GENERAL = 'general',
	ERROR_WARNING = 'error warning',
}
